module.exports = __webpack_public_path__ + "img/sun-behind-rain-cloud.0ca38c08.png";